import { Texto } from '@gravitate-js/excalibrr'
import { Flex, Spin } from 'antd'

export const OutageQueryStatusIndicator = ({ isLoading }: { isLoading?: boolean }) => {
  if (!isLoading) return null
  return (
    <Flex className='mx-2' gap={4}>
      <Spin />
      <Texto appearance='hint' weight='bold'>
        Re-calculating Outages
      </Texto>
    </Flex>
  )
}
